/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SupportBanner } from './SupportBanner';
import { SUPPORT_COPY, SUPPORT_MODE } from '../../../../constants/support';
const meta = {
    title: 'Features/AIChatWidget/SupportBanner',
    component: SupportBanner,
    parameters: { layout: 'padded' },
    args: { onEndChat: () => undefined, onDismissEnded: () => undefined },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 600, padding: 16, background: '#fff', borderRadius: 8 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const WaitingForAnAgent = { args: { mode: SUPPORT_MODE.QUEUED } };
export const ChattingWithSupport = { args: { mode: SUPPORT_MODE.HUMAN } };
export const Ending = { args: { mode: SUPPORT_MODE.HUMAN, isEnding: true } };
export const ChatEnded = { args: { mode: SUPPORT_MODE.ENDED, showEnded: true } };
export const ChatEndedWithLateReply = {
    args: { mode: SUPPORT_MODE.ENDED, showEnded: true, unreadCount: 1 }
};
export const WithRefusedSendNotice = {
    args: { mode: SUPPORT_MODE.HUMAN, notice: SUPPORT_COPY.CONFLICT_NOTICE }
};
